import { render, staticRenderFns } from "./RedirectComponent.vue?vue&type=template&id=379128c6&"
import script from "./RedirectComponent.vue?vue&type=script&lang=js&"
export * from "./RedirectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports